import config from '../../config'
const { REDIRECT_NEW_PARENT_APP_URL } = config

export const redirectToNewParentApp = async({ districtId, resource, resourceId, flyerId, flyerIsPending = false }) => {
  let route =  '';
  const isSchoolFlyerboard = resource === 'schools';
  const urlParams = new URLSearchParams(window.location.search)
  const staff = urlParams.get('staff')

  if(staff || flyerIsPending) return;

  if (flyerId) {
     route = `district/${districtId}/flyer/${flyerId}?audienceId=${resourceId}`
  } else {
     route = `jar?audienceId=${resourceId}&tab=school&districtId=${districtId}&audienceType=${isSchoolFlyerboard ? 'school' :'district'}`
  }

  window.location.href = `${REDIRECT_NEW_PARENT_APP_URL}/${route}`;
}



// WEBPACK FOOTER //
// ./src/shared/utils/redirectToNewParentApp.js